module.exports = __webpack_public_path__ + "static/media/BluePintetBGCross.45e3d2f6.svg";